// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-layout {
  height: 100%;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}

.simple-layout > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.simple-layout .layout-content {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1 1 100%;
}

.simple-layout .layout-content > div {
  width: 100%;
}

.simple-layout .divider.top {
  margin-bottom: 0px;
}

/* Message layout */
.system-log .message-list {
  width: 100%;
  margin: 10px 0px !important;
}

.system-log .status.item i {
  float: left;
}

.system-log .status.item .text {
  margin-top: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.system-log .status.item .time {
  color: gray;
}

.system-log .status.item .label {
  color: gray;
  margin-right: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/routes/Events/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".simple-layout {\n  height: 100%;\n  padding: 20px;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: white;\n}\n\n.simple-layout > div {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.simple-layout .layout-content {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  flex: 1 1 100%;\n}\n\n.simple-layout .layout-content > div {\n  width: 100%;\n}\n\n.simple-layout .divider.top {\n  margin-bottom: 0px;\n}\n\n/* Message layout */\n.system-log .message-list {\n  width: 100%;\n  margin: 10px 0px !important;\n}\n\n.system-log .status.item i {\n  float: left;\n}\n\n.system-log .status.item .text {\n  margin-top: 5px;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.system-log .status.item .time {\n  color: gray;\n}\n\n.system-log .status.item .label {\n  color: gray;\n  margin-right: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
